<template>
  <div class="idtr-block idtr-section">
    <div class="idtr-band">{{ text.accountsTitle }}</div>
    <div class="idtr-section__body">
      <account-block :index="0" @remove="$emit('remove', $event)" />
    </div>
  </div>
</template>

<script>
import AccountBlock from "./AccountBlock.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {AccountBlock},
  data: () => ({text: IDTR_TEXT}),
};
</script>
